import React from "react";
import Section from "./layouts/Section";
import PageLayout from "./layouts/PageLayout";

const Team = () => {
  return (
    <PageLayout title="Cell Station – Home | Expert Cellphone Repair">
      <Section title="Team">
        <section className="section cm-team pt-60">
          <div className="container">
            <div className="row">
              {/* Team Member 1 */}
              <div className="col-lg-6">
                <div className="team-item mt-40">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <img
                        className="team-img img-fluid"
                        src={process.env.PUBLIC_URL + "/assets/images/team/01.jpg"}
                        alt="Lucinda Banfield"
                      />
                    </div>
                    <div className="col-sm-6 mt-4 mt-sm-0">
                      <h5 className="text-dark font-w-600">Lucinda Banfield</h5>
                      <p className="small text-primary text-uppercase font-w-600 mt-1">
                        Repair Technician
                      </p>
                      <p className="mt-15">
                        PC Repair Technician, installs, evaluates, & troubleshoots.
                      </p>
                      <SkillBar label="Softer Bag Fix" value={95} />
                      <SkillBar label="Computer Repair" value={85} />
                      <SkillBar label="Smartphone Repair" value={92} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Team Member 2 */}
              <div className="col-lg-6">
                <div className="team-item mt-40">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <img
                        className="team-img img-fluid"
                        src={process.env.PUBLIC_URL + "/assets/images/team/02.jpg"}
                        alt="Lucinda Banfield"
                      />
                    </div>
                    <div className="col-sm-6 mt-4 mt-sm-0">
                      <h5 className="text-dark font-w-600">Lucinda Banfield</h5>
                      <p className="small text-primary text-uppercase font-w-600 mt-1">
                        Repair Technician
                      </p>
                      <p className="mt-15">
                        PC Repair Technician, installs, evaluates, & troubleshoots.
                      </p>
                      <SkillBar label="Softer Bag Fix" value={90} />
                      <SkillBar label="Computer Repair" value={97} />
                      <SkillBar label="Smartphone Repair" value={81} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Team Member 3 */}
              <div className="col-lg-6">
                <div className="team-item mt-40">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <img
                        className="team-img img-fluid"
                        src={process.env.PUBLIC_URL + "/assets/images/team/03.jpg"}
                        alt="Marteen Khourn"
                      />
                    </div>
                    <div className="col-sm-6 mt-4 mt-sm-0">
                      <h5 className="text-dark font-w-600">Marteen Khourn</h5>
                      <p className="small text-primary text-uppercase font-w-600 mt-1">
                        Repair Technician
                      </p>
                      <p className="mt-15">
                        PC Repair Technician, installs, evaluates, & troubleshoots.
                      </p>
                      <SkillBar label="Softer Bag Fix" value={90} />
                      <SkillBar label="Computer Repair" value={97} />
                      <SkillBar label="Smartphone Repair" value={81} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Team Member 4 */}
              <div className="col-lg-6">
                <div className="team-item mt-40">
                  <div className="row align-items-center">
                    <div className="col-sm-6">
                      <img
                        className="team-img img-fluid"
                        src={process.env.PUBLIC_URL + "/assets/images/team/04.jpg"}
                        alt="Martina Banfield"
                      />
                    </div>
                    <div className="col-sm-6 mt-4 mt-sm-0">
                      <h5 className="text-dark font-w-600">Martina Banfield</h5>
                      <p className="small text-primary text-uppercase font-w-600 mt-1">
                        Repair Technician
                      </p>
                      <p className="mt-15">
                        PC Repair Technician, installs, evaluates, & troubleshoots.
                      </p>
                      <SkillBar label="Softer Bag Fix" value={95} />
                      <SkillBar label="Computer Repair" value={85} />
                      <SkillBar label="Smartphone Repair" value={92} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Section>
    </PageLayout>
  );
};

// Reusable Skill Bar Component
const SkillBar = ({ label, value }) => (
  <div className="barWrapper">
    <span className="progress-text">{label}</span>
    <div className="progress">
      <div className="progress-bar" data-value={value}>
        <span className="skill-percent">{value}</span>
      </div>
    </div>
  </div>
);

export default Team;
